import classNames from "classnames"

import { UITypes } from "types"
import styles from "assets/scss/index.module.scss"

import useExportCSV from "hooks/useExportCSV"
import { ButtonNew } from "components/form/ButtonNew"
import { CheckboxNew } from "components/form/CheckboxNew"

import { referralsTableHeaderCells } from "./referralsTableHeaderCells"

interface Props {
  tableRows: UITypes.TableBodyRow[]
  onAddClick: () => void
  onArchiveChange: (showArchive: boolean) => void
}

export const MyReferralsHeader = ({ tableRows, onAddClick, onArchiveChange }: Props) => {
  const { handleLocalExport } = useExportCSV({
    params: {},
    headerCells: referralsTableHeaderCells,
    fileName: "referrals",
  })

  return (
    <nav className={styles.tableNavWrapper}>
      <div>
        <ButtonNew color="blue" onClick={onAddClick}>
          Add New
        </ButtonNew>
      </div>
      <div className={classNames(styles.tableNavButtonsWrapper)}>
        <CheckboxNew
          className={styles.tableNavItem}
          isReverse={true}
          id="archive"
          onChange={event => onArchiveChange(event.target.checked)}
        >
          Show Archive
        </CheckboxNew>
        <ButtonNew
          className={styles.tableNavItem}
          onClick={() => handleLocalExport(tableRows)}
          disabled={!tableRows.length}
        >
          Export
        </ButtonNew>
      </div>
    </nav>
  )
}
